export default __webpack_public_path__ + "static/media/6.e10966f3.jpg";